import { getAccountExperience } from '#client/configs/accountExperience';

import { useEnterprise } from './useEnterprise';

export function useAccountExperience() {
  const { enterprise, loading } = useEnterprise();
  const accountExperience = getAccountExperience(enterprise);

  return {
    accountExperience,
    enterprise,
    loading,
  };
}
